<template>
  <div class="regular-header">
	<navbar />
    <headerGrid>
      <div class="font-size-custom-max-48"><h1 id="font-calc-kiosk">Netflix lovers</h1></div>
      <p>Een van onze punten waar wij ons door onderscheiden is kennis delen. We verzamelen geen maillijst, spammen je niet en we hopen zelfs dat je het met anderen deelt. Zoals je ziet is onze kiosk niet enorm gevuld, we zijn secuur met wat we delen.</p>
      <a v-scroll-to="'#first-kiosk-item'"><img src="../assets/Folded_Paper_asset_arrow_down.png"></a>
   </headerGrid>

  <oddEvenGrid class="hidden" id="first-kiosk-item" v-infocus="'showElementCase'">
    <div class="odd-even-grid">
      <div class="text-box">
        <div class="content">
          <h3>Product design: illustratie</h3>
          <p>Deze paper is nog in de maak. Wij laten hem graag zien als de paper compleet is. Even geduld nog.</p>
          <a>Beschikbaar juni 2019</a>
        </div>
      </div>
      <div class="img-box">
        <img src="../assets/Folded_Paper_kiosk-test-blur.png">
      </div>
    </div>
  </oddEvenGrid>

  <oddEvenGrid class="hidden" v-infocus="'showElementCase'">
    <div class="odd-even-grid">
       <div class="img-box">
        <img src="../assets/Folded_Paper_kiosk-test-blur.png">
      </div>
      <div class="text-box">
        <div class="content">
          <h3>Branding: wat verstaan wij daar onder? </h3>
          <p>Deze paper is nog in de maak. Wij laten hem graag zien als de paper compleet is. Even geduld nog.</p>
          <a>Beschikbaar juni 2019</a>
        </div>
      </div>
    </div>
  </oddEvenGrid>


  <oddEvenGrid class="hidden" v-infocus="'showElementCase'">
    <div class="odd-even-grid">
      <div class="text-box">
        <div class="content">
          <h3>Animatie gaat veel verder dan "gewoon" uitleggen</h3>
          <p>Deze paper is nog in de maak. Wij laten hem graag zien als de paper compleet is. Even geduld nog.</p>
          <a>Beschikbaar juni 2019</a>
        </div>
      </div>
      <div class="img-box">
        <img src="../assets/Folded_Paper_kiosk-test-blur.png">
      </div>
    </div>
  </oddEvenGrid>
  
  </div>
</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';
import headerGrid from '@/components/generalLayout/headerGrid.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';


export default {
  name: 'kiosk',

  components:{
    headerGrid,
    oddEvenGrid,
    navbar
  },
    directives: {
    infocus: {
      isLiteral: true,
      inserted: (el, binding, vnode) => {
        let f = () => {
          let rect = el.getBoundingClientRect()
          let inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          )
          if (inView) {
            el.classList.add(binding.value)
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
        f()
      }
    }
  },
}


</script>

<style lang="scss" scoped>
 .img-box{
  img{
      width: auto !important;
      max-height:400px !important;
      margin: 0 auto;
      display: block;
      border-radius: 0; 
  }
}


</style>
